import { Component, Input, Renderer2 } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipOption, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldBase, FieldOption } from '@nagel-types';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { IconComponent } from '@nagel-assests';
import { getIcons } from '@nagel-utils';

@Component({
    selector: 'lib-chip-set',
    imports: [
        MatFormFieldModule,
        MatChipsModule,
        IconComponent,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule
    ],
    templateUrl: './chip-set.component.html',
    styleUrl: './chip-set.component.scss'
})
export class ChipFormFieldComponent extends BaseFieldComponent {
    @Input() override field!: FieldBase<unknown>;
    @Input() override form!: FormGroup;

    @Input() key: string = '';
    @Input() value: string[] = [];
    @Input() options: FieldOption[] = [];

    ngOnInit() {
        this.key = this.field?.key ?? this.key;
        this.value = this.field?.value as string[] ?? [];
        this.options = this.field?.options ?? [];
    }

    constructor(private renderer: Renderer2) {
        super();
    }

    isSelected(value: unknown) {
        return (this.value as unknown[]).includes(value);
    }

    getIcons = (icon: string | string[]) : string[] => getIcons(icon);

    onMouseEnter(chip: MatChipOption) {
        if (!chip.selected) {
            this.renderer.addClass(chip._elementRef.nativeElement, 'mdc-evolution-chip--selected');
        }
    }

    onMouseLeave(chip: MatChipOption) {
        if (!chip.selected) {
            this.renderer.removeClass(chip._elementRef.nativeElement, 'mdc-evolution-chip--selected');
        }
    }
}